// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"In-z","badgeLink":"Jn-z","category":"Kn-z"};